export default {"src":"/_next/static/media/ourstory.c71c0f27.svg","height":411,"width":450};